var React = require('react');

function G3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"G3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M0,38.55a40,40,0,0,0,34.44,41L37.18,0A40,40,0,0,0,0,38.55Z","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("path",{"d":"M35.71,39.78,26.45,79.46A41.12,41.12,0,0,0,71.58,48Z","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

G3.defaultProps = {"viewBox":"0 0 71.58 79.78"};

module.exports = G3;

G3.default = G3;
